'use es6';

import PropTypes from 'prop-types';
import { Component } from 'react';
import { PopoverBodyMode } from 'rich-text-lib/constants/popover';
import EditLinkPopoverBodyV2 from 'rich-text-lib/components/links/EditLinkPopoverBodyV2';
import TinyMcePopover from './TinyMcePopover';
import { trackInteraction } from '../utils/usageTracking';
import { anchorNodeContainsOnlyTextElements } from '../utils/link';
import withPopoverModeState from './withPopoverModeState';
import { jsx as _jsx } from "react/jsx-runtime";
class LinkEditPopover extends Component {
  constructor(...args) {
    super(...args);
    this.handleTogglePopover = ({
      shouldOpen = true
    }) => {
      this.props.onModeChange(shouldOpen ? PopoverBodyMode.EDIT : PopoverBodyMode.PREVIEW);
    };
    this.handleUpdate = linkInfo => {
      if (linkInfo.href !== '' && this.props.open) {
        this.props.onUpdate(linkInfo);
      }
    };
    this.handleSave = linkInfo => {
      this.props.onUpdate(linkInfo);
      this.handleClose();
    };
    this.handleClose = () => {
      this.props.onClose();
      this.props.onModeChange(PopoverBodyMode.PREVIEW);
    };
    this.trackLinkUsage = (trackingAction, trackingValues) => {
      trackInteraction(this.props.editor, 'tinymceLink', trackingAction, trackingValues);
    };
  }
  componentDidMount() {
    this.props.editor.on('ToggleLinkEditPopover', this.handleTogglePopover);
  }
  componentWillUnmount() {
    this.props.editor.off('ToggleLinkEditPopover', this.handleTogglePopover);
  }
  render() {
    const {
      children,
      editor,
      target,
      onSelectFile,
      onRemove,
      fetchPages,
      fetchMeetingsByUsers,
      fetchAnchors,
      fetchMeetingBySlug,
      fetchFileByUrl,
      showRefAndTargetControls,
      useEmailSubscription,
      allowFileDownload,
      allowMeetingLink,
      allowRawLinksOnly,
      emailSubscriptionLinkTypes,
      allowAnchorLinks,
      fetchPageBySlug,
      mode,
      onModeChange,
      open,
      externalLink,
      linkText,
      href,
      relAttr,
      onAnchorPreviewClick,
      allowEmailWebVersionLink
    } = this.props;
    const canModifyLinkText = !allowRawLinksOnly && anchorNodeContainsOnlyTextElements(target);
    return /*#__PURE__*/_jsx(TinyMcePopover, {
      placement: "bottom",
      editor: editor,
      target: target,
      onRemove: onRemove,
      open: !!target && open,
      animateOnToggle: false,
      renderContent: () => /*#__PURE__*/_jsx(EditLinkPopoverBodyV2, {
        dropdownClassName: "mce-ui-select",
        tooltipClassName: "mce-link-tooltip",
        externalLink: externalLink,
        linkText: linkText,
        canModifyLinkText: canModifyLinkText,
        href: href,
        relAttr: relAttr,
        fetchPages: fetchPages,
        fetchMeetingsByUsers: fetchMeetingsByUsers,
        fetchAnchors: fetchAnchors,
        fetchMeetingBySlug: fetchMeetingBySlug,
        onSelectFile: onSelectFile,
        showRefAndTargetControls: showRefAndTargetControls,
        useEmailSubscription: useEmailSubscription,
        allowFileDownload: allowFileDownload,
        allowMeetingLink: allowMeetingLink,
        allowRawLinksOnly: allowRawLinksOnly,
        emailSubscriptionLinkTypes: emailSubscriptionLinkTypes,
        allowAnchorLinks: allowAnchorLinks,
        fetchPageBySlug: fetchPageBySlug,
        fetchFileByUrl: fetchFileByUrl,
        mode: mode,
        onModeChange: onModeChange,
        scopes: editor.settings.scopes,
        userId: editor.settings.userId,
        trackLinkUsage: this.trackLinkUsage,
        onAnchorPreviewClick: onAnchorPreviewClick,
        onSave: this.handleSave,
        onClose: this.handleClose,
        renderLinkPopoverAlert: editor.settings.renderLinkPopoverAlert,
        allowEmailWebVersionLink: allowEmailWebVersionLink
      }),
      children: children
    });
  }
}
LinkEditPopover.propTypes = {
  children: PropTypes.object,
  editor: PropTypes.object.isRequired,
  open: PropTypes.bool.isRequired,
  onRemove: PropTypes.func.isRequired,
  target: PropTypes.instanceOf(HTMLAnchorElement),
  linkText: PropTypes.string.isRequired,
  href: PropTypes.string.isRequired,
  onSelectFile: PropTypes.func.isRequired,
  externalLink: PropTypes.bool.isRequired,
  relAttr: PropTypes.array,
  onClose: PropTypes.func.isRequired,
  onUpdate: PropTypes.func.isRequired,
  showRefAndTargetControls: PropTypes.bool.isRequired,
  fetchPageBySlug: PropTypes.func.isRequired,
  fetchPages: PropTypes.func.isRequired,
  fetchMeetingsByUsers: PropTypes.func.isRequired,
  fetchAnchors: PropTypes.func.isRequired,
  fetchMeetingBySlug: PropTypes.func.isRequired,
  fetchFileByUrl: PropTypes.func.isRequired,
  useEmailSubscription: PropTypes.bool,
  allowFileDownload: PropTypes.bool,
  allowMeetingLink: PropTypes.bool,
  allowRawLinksOnly: PropTypes.bool,
  emailSubscriptionLinkTypes: PropTypes.array,
  allowAnchorLinks: PropTypes.bool,
  mode: PropTypes.oneOf(Object.values(PopoverBodyMode)),
  onModeChange: PropTypes.func,
  onAnchorPreviewClick: PropTypes.func,
  allowEmailWebVersionLink: PropTypes.bool
};
export default withPopoverModeState(LinkEditPopover);